import { WithHoldingTaxDto } from "./with-holding-tax-dto"

export class PendingVendorDto{
    public account_group:string=''
    public new_account_group:string=''
    public payment_term:string=''
    public purchase_organization:string=''
    public with_holding_tax:string=''
    public business_name:string=''
    public get_user:string=''
    public evaluatedScore:string=''
    public riskScore:string=''
    public reject_reason:string=''
    public thrid_party_business_score_doc:string=''
    public thrid_party_evaluated_scorecard_doc:string=''

    public reconciliation_type:string=''
    public with_holding_tax_type:string=''
    public with_holding_tax_code:string=''
    public exemption_number:string=''
    public exem:string=''
    public exempt_from:string=''
    public exempt_to:string=''

    public with_holding_list?: WithHoldingTaxDto[]
}
